import React, { memo } from 'react';
import { Box, Divider, HStack, Skeleton, VStack } from 'native-base';
const TaskCardSkeleton = ({
  bgColor
}) => {
  return /*#__PURE__*/React.createElement(VStack, {
    testID: 'task-card-skeleton',
    bg: bgColor,
    borderColor: 'lightBlue.400',
    borderRadius: '4',
    shadow: 4,
    borderWidth: 1,
    p: 4,
    mb: 2
  }, /*#__PURE__*/React.createElement(VStack, {
    borderRadius: 4,
    space: 4
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    w: "100%"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    h: "4",
    w: "44%",
    startColor: "lightBlue.400",
    borderRadius: "4"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    h: "4",
    w: "8%",
    startColor: "lightBlue.400",
    borderRadius: "4"
  }), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    alignItems: 'flex-end'
  }, /*#__PURE__*/React.createElement(Skeleton, {
    h: "4",
    w: "40%",
    startColor: "lightBlue.400",
    borderRadius: "4"
  }))), /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Skeleton, {
    h: "4",
    w: "44%",
    startColor: "lightBlue.400",
    borderRadius: "4"
  })), /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Divider, {
    orientation: 'horizontal',
    h: "1",
    borderRadius: "1",
    bg: "lightBlue.200"
  })), /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Skeleton, {
    h: "4",
    w: "100%",
    startColor: "lightBlue.400",
    borderRadius: "4"
  }))));
};
export default /*#__PURE__*/memo(TaskCardSkeleton);
//# sourceMappingURL=index.js.map